export default __webpack_public_path__ + "static/media/YAS0320.34I-29781_-17222_0.dc868be4.jpg";